import React, { 
    useState, 
    useEffect } from 'react';
import {
    Alert,
    Modal,
    notification,
} from 'antd';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import SwapForm from './modem-swap/SwapForm';

import MacIMage from '../images/03-19_MACAddressIllustration_V04.jpg';
import startLogo from '../images/Start.caKoodoLogo_Website_grey.svg';

const siteDomain = headerVars.siteDomain;

function ModemSwap() {
    const [modalOpen, setModalOpen] = useState(false);
    const [autoSwapDate, setAutoSwapDate] = useState([]);
    const siteDomain = headerVars.siteDomain;

    const [api, contextHolder] = notification.useNotification();

    const captchaKey = "6LdmP8QkAAAAACX1XkPWEZ08HGoIkk1nClZiagMJ";

    useEffect(() => {  }, []);

    const handleOpenQuestionModal = () => {
        setModalOpen( true );
    }

    const handleCloseModal = () => {
        setModalOpen( false );
    }

    return (
        <div className="react-contact-form react-modem-swap-form">
            <img className="start-logo" src={ startLogo } />
            <h1>Modem swap form</h1>
            <Alert
                message=""
                className='services-alert'
                description={
                    <div className="automated-provisioning-date-container">
                        <p>If you run into any issues completing the swap,<br/>contact our Customer Care team at <a href="tel:1-866-434-5888" >1-866-434-5888</a> for assistance.</p>
                        { autoSwapDate }
                    </div>
                }
                banner
                closable
            />
            <div className='modem-swap-form-container'>
                <GoogleReCaptchaProvider
                    reCaptchaKey={ captchaKey }>
                    <SwapForm
                        handleOpenQuestionModal={ handleOpenQuestionModal }
                        setAutoSwapDate={ setAutoSwapDate }
                    />
                </GoogleReCaptchaProvider>
            </div>
            <Modal
                title="Where's my MAC Address?"
                centered
                open={ modalOpen }
                footer={[]}
                onCancel={ handleCloseModal }
                width={ 700 }
            >
                <div className='channel-modal-content'>
                    <div className='channel-modal-img-container' >
                        <img src={ MacIMage } />
                    </div>
                    <div style={{marginTop:'1.5rem'}}>
                        <p>Your MAC address can usually be found on the back (or bottom) of your modem, on or near a barcoded sticker.</p>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default ModemSwap
